import {useTranslation} from 'react-i18next';
import {useTextEntryContext} from '../context/TextEntryContextProvider';

type UseTextFn = (key: string, fallback?: string) => string;

const useText = (): UseTextFn => {
  const {allTextEntriesData} = useTextEntryContext();
  const {t} = useTranslation();

  return (key: string, fallback: string = ''): string =>
    allTextEntriesData[key] ?? t(fallback || key);
};

export default useText;
